import auth from './auth';
import web_form from './web_form';

export default {
	auth,
	web_form
};
